export default {"src":"/_next/static/media/flowers.2ae144fc.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};